<template>
	<div id="create-custom-lut-folder-modal" class="modal-new hidden">
		<span class="title">Create a Folder</span>
		<input v-model="name" type="text" name="folder-name" placeholder="Enter folder name" class="regex-check" />
		<div class="buttons-continer">
			<v-btn :disabled="processing" dark class="modal-btn --primary" @click="createFolder">Create</v-btn>
			<button type="button" class="modal-btn --cancel" @click="onCancel">Cancel</button>
		</div>
	</div>
</template>

<script>
export default {
    data() {
        return {
            name: "",
            processing: false
        }
    },

    methods: {
        async createFolder() {
            if (this.name == "") return;

            this.processing = true;
            await this.$store.dispatch("UserFilesCustomLuts/createFolder", this.name);
            await this.$store.dispatch("UserFilesCustomLuts/index");
            window._Adjustments.customLUT.refreshAllBlocks();
            this.processing = false;
            window.UI.hideModal();
            window.UI.showModal(UI.modals.customLUT.importLuts.el);
        },
        onCancel() {
            window.UI.hideModal();
            window.UI.showModal(UI.modals.customLUT.edit.el);
        },
    },
};
</script>

<style></style>
